import styled from 'styled-components';

import { fontFamilySize, px } from '../../../../../../contrib/ui';

export const StyledSelectHolesForCTP = styled.div`
  .round-holes-selection {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    margin-bottom: ${px(20)};

    .round-label {
      width: ${px(450)};
    }

    .hole-select-container {
      display: inline-block;

      margin-right: ${px(10)};

      .hole-checkbox {
        padding-top: 5px;
      }

      .checkbox-label {
        ${fontFamilySize('Bold', 16)}
        display: inline-block;
        margin-left: ${px(-10)};
        margin-right: ${px(15)};
        width: ${px(20)};
        text-align: end;
      }
    }
  }
`;
